<app-dialog [title]="(selectedService.lastSelectedUnit$ | async).name" [showDialogActions]="false">

  <ng-container appDialogContent>
    <app-unit-info-carousel></app-unit-info-carousel>
  </ng-container>

</app-dialog>
